import { useState } from 'react';

export const useLoader = () => {
  const [isLoaderVisible, setIsLoaderVisible] = useState<boolean>(false);

  const showLoader = () => {
    setIsLoaderVisible(true);
  };
  const hideLoader = () => {
    setIsLoaderVisible(false);
  };
  return {
    isLoaderVisible,
    showLoader,
    hideLoader,
  };
};
